export default "__VITE_ASSET__DaXC1vmw__"